import TypesController from './types.controller';

export default {
    template: require('./types.tpl.html'),
    controller: TypesController
};
